// Webpack Imports
import 'bootstrap';


$(document).on('click', '#search-tabs .nav-link', function(e){
    e.preventDefault();
    $.ajax({
        type: "GET",
        url : $(this).attr('href'),
        success: function(data){
            var $result = $(data).find('.real-content');
            $('.real-content').html($result);
        }
    })
});

$('#search-trigger').click(function(){
    $('#search-layer').addClass('opened');
});
$('#close-search').click(function(){
    $('#search-layer').removeClass('opened');
});

(function( $ ) {
    $(function() {
        var searchURL = "/wp-admin/admin-ajax.php";
        $( "#s" ).autoComplete({
            minChars: 2,
            source: function(term, suggest){
                //try { searchRequest.abort(); } catch(e){}
                $.post(searchURL, { s: term, action: 'my_search' }, function(res) {
                    suggest(res.data);
                });
            }
        });
    });

})( jQuery );

( function ( $ ) {
	'use strict';

	// JQuery fallback: add title attribute from placeholder
	$( 'input, textarea' ).attr( 'title', function () {
		return $( this ).attr( 'placeholder' );
	} );

	// Focus Search if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.focus();
		}
	} );

}( jQuery ) );


jQuery(document).ready(function($) {

	$('.woocommerce-ordering select').select2(); // Add your target select field


});